import { NgModule } from '@angular/core';

import { SocialComponent } from './Core/components/Social/social.component';
import { SocialCoreModule } from './Core/social-core.module';
import { SocialRoutingModule } from './SocialRouter/social-routing.module';
import { IntelligenceModule } from './Intelligence/intelligence.module';

import { ThemeApiService } from '../api/social/theme.api.service';


@NgModule({
    imports: [
        SocialCoreModule,
        SocialRoutingModule,
        IntelligenceModule
    ],
    exports: [
        SocialComponent,
        IntelligenceModule
    ],
    providers: [
        ThemeApiService
    ],
})
export class SocialModule {}
